<template>
  <draggable
    v-model="list"
    tag="div"
    class="list-group"
    v-bind="dragOptions"
    @end=handleEndDrag
  >
  <q-card class="my-card q-mb-xs list-group-item" :key="el.id" v-for="(el) in allRouters" :self-id="el.id" :parent-id="el.parent" :app-title="el.title" :app-name="el.appName">
      <q-card-section class="">
        <div  class="row q-mb-xs list-group-item"> {{ el.title }} </div>
        <ManagerMenu v-if="el.elements" :data-list=el.elements :old-parent=el ></ManagerMenu>
      </q-card-section>
    </q-card>
  </draggable>
</template>

<script>
  import draggable from 'vuedraggable'

  export default {
    name: "ManagerMenu",
    components: { draggable },
    props: {
      dataList :{
        type: Array,
        default: null
      },
      oldParent: {
        type: Object,
        default: null
      }
    },
    computed: {
      allRouters: {
        get(){
          let list = this.dataList? this.dataList : this.$store.getters['allRouters']
          this.list = this.$store.getters['allRouters']
          return list
        },
        set(value) {},
      },
    },
    data() {
      return{
        list : [],
        dragOptions: {
          animation: 0,
          group: "description",
          disabled: false,
          ghostClass: "ghost"
        },
      }
    },
    created() {},
    methods:{
      handleEndDrag(row) {
        let parentBlock = row.to.parentElement.parentElement
        let dragItem = row.item
        let parentID = Number.parseInt(row.item.getAttribute("parent-id"))
        let newList = []

        if (parentID !== 0) {
          let findOrginParent = {}
          this.list.map(r => {
            if ( r.id === parentID) {
              findOrginParent = r
            }
          })
          // 移除原本位置
          if (findOrginParent) {
            findOrginParent.elements.map((r, i)=>{
              if (r.id === Number.parseInt(row.item.getAttribute("self-id")) ) {
                findOrginParent.elements.splice(i, 1)
              }
            })
          }
          // 加到放開後的parent 底下
          this.list.map(r => {
            if (r.id === Number.parseInt(parentBlock.getAttribute("self-id"))) {
              let appRow = {
                id: Number.parseInt(dragItem.getAttribute("self-id")),
                parent: r.id,
                title: dragItem.getAttribute("app-title"),
                appName: dragItem.getAttribute("app-name"),
              }
              r.elements.splice(row.newIndex, 0, appRow)
            }
          })

          this.allRouters = this.allRouters
          
          this.$store.dispatch("updateMenuSetup", this.list)
        }else {
          let findSelf = this.list.find(r => r.id === Number.parseInt(dragItem.getAttribute("self-id")))
          
          this.list.map((r, i) => {
            if ( i === row.newIndex) {
              newList.push(findSelf)
            }
            if (r.id !== findSelf.id ) {
              newList.push(r)
            }
          })
          this.allRouters = newList
          this.list = newList
          this.$store.dispatch("updateMenuSetup", this.list)
        }

      },
    } 
  }
</script>

